export const access = {
    sideMenu: {
        dashboard: {
          hide: false,
          disable: false,
          lock: false
        },
        messages: {
          hide: false,
          disable: false,
          lock: false
        },
        appointment: {
          hide: true,
          disable: false,
          lock: false
        },
        care_rewards: {
          hide: false,
          disable: false,
          lock: false
        },
        personal_information: {
          hide: false,
          disable: false,
          lock: false
        }
    },
    message_detail: {
        all_msg_btn: {
            hide: false,
            disable: false,
            lock: false
        }
    }
}